export function load(url)
{
  import(/* @vite-ignore */url)
}
export function initialize($ref, configuration) {
  const setExtranetHeaderAttribute = (selector, map) => {
    const el = $ref.value.querySelector(selector)
    Object.keys(map).forEach((prop) => (el[prop] = map[prop]))
  }
  setExtranetHeaderAttribute('extranet-header',configuration)
  setExtranetHeaderAttribute('extranet-header', {
    authFailureCallback: () => {
      return new Promise((resolve, reject) => {
        fetch('/auth/refresh-token')
          .then((res) => {
            const data = res.json()
            setExtranetHeaderAttribute('extranet-header', { jwt: data.token })
            setExtranetHeaderAttribute('extranet-header', { refreshToken: data.refresh_token })
            resolve(data)
          })
          .catch((e) => {
            reject(e)
            console.error(e)
            window.location.reload()
          })
      })
    },
  })
}
